import styled from 'styled-components';
import theme from '../../theme';

export const StyledIndusindFaq = styled.div`
  padding: 10px 0px;
  .wearable-breadcrumb{
    margin: 5px 0px 20px;
    .ant-breadcrumb-link{
      font-size: 13px;
      color: ${theme.LandingBlack};
      &:hover{
        color: ${theme.primaryColor};
      }
    }
    .ant-breadcrumb-separator{
      color: ${theme.primaryColor};
      font-size: 14px;
      font-weight: 600;
    }
  }
  .wearables-faq {
    margin: 10px 0px 20px;
    .ant-card-body {
      padding: 30px;
      .wearable-faq-collapse{
        border: none;
        background: transparent;
        .ant-collapse-item{
          border-bottom: none;
          background: ${theme.hypeGray};
          border-radius: 6px;
          border: 1px solid ${theme.nancyBorder};
          margin: 8px 0px;
          .ant-collapse-header{
            font-weight: 600;
            padding: 14px 16px;
          }
          &.ant-collapse-item-active{
            .ant-collapse-header{
              border-radius: 6px;
              background: ${theme.whiteColor};
            }
            .ant-collapse-content-active{
              border-top: none;
              border-radius: 6px;
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// client/containers/IndusindZingerCardsFaqs/StyledIndusindFaqs.js